import type { Opportunity } from "@skv/core";
import { CustomError } from "@skv/core";

type OpportunityFetchStart = {
  type: "OPPORTUNITY:FETCH:START";
};

type OpportunityFetchEnd = {
  type: "OPPORTUNITY:FETCH:END" | "OPPORTUNITY:FETCH:END:FROMCACHE";
  payload: {
    data: Opportunity;
  };
};

type OpportunityFetchError = {
  type: "OPPORTUNITY:FETCH:ERROR";
  payload: {
    error: CustomError;
    id: string;
  };
};

type OpportunityFetchErrorUnknown = {
  type: "OPPORTUNITY:FETCH:ERROR:UNKNOWN";
  payload: {
    error: CustomError;
  };
};

type OpportunityErrorSet = {
  type: "OPPORTUNITY:ERROR:SET";
  payload: {
    error: CustomError;
  };
};

type OpportunityErrorReset = {
  type: "OPPORTUNITY:ERROR:RESET";
};

export type ActionTypes =
  | OpportunityFetchStart
  | OpportunityFetchEnd
  | OpportunityFetchError
  | OpportunityFetchErrorUnknown
  | OpportunityErrorSet
  | OpportunityErrorReset;

export interface State {
  loading: boolean;
  error: null | CustomError;
  data: {
    [key: string]: Opportunity | CustomError;
  };
}

export const reducer = (
  state: State = {
    loading: false,
    error: null,
    data: {},
  },
  action: ActionTypes
): State => {
  switch (action.type) {
    case "OPPORTUNITY:FETCH:START":
      return {
        ...state,
        loading: true,
        error: null,
      };
    case "OPPORTUNITY:FETCH:END":
    case "OPPORTUNITY:FETCH:END:FROMCACHE":
      return {
        ...state,
        loading: false,
        error: null,
        data: {
          ...state.data,
          [action.payload.data.id]: action.payload.data,
        },
      };
    case "OPPORTUNITY:FETCH:ERROR":
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        data: {
          ...state.data,
          [action.payload.id]: action.payload.error,
        },
      };
    case "OPPORTUNITY:FETCH:ERROR:UNKNOWN":
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    case "OPPORTUNITY:ERROR:SET":
      return {
        ...state,
        error: action.payload.error,
      };
    case "OPPORTUNITY:ERROR:RESET":
      return {
        ...state,
        loading: false,
        error: null,
      };
    default:
      return state;
  }
};
